import { useEffect, useState } from "react";
import { registerPwa, applyPwaUpdate } from "@/lib/pwa";
import { WifiOff, RefreshCw } from "lucide-react";

export default function PwaStatus() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [updateReady, setUpdateReady] = useState(false);

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    registerPwa(() => setUpdateReady(true));
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  if (!offline && !updateReady) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-[100] flex flex-col items-center gap-2 p-2 pointer-events-none">
      {offline && (
        <div data-testid="offline-banner" className="pointer-events-auto flex items-center gap-2 rounded-full bg-zinc-900 text-white text-sm px-4 py-2 shadow-lg border border-white/10">
          <WifiOff size={15} className="text-amber-400" />
          <span>Sei offline: alcune funzioni non sono disponibili.</span>
        </div>
      )}
      {updateReady && (
        <div data-testid="update-banner" className="pointer-events-auto flex items-center gap-3 rounded-full bg-primary text-primary-foreground text-sm px-4 py-2 shadow-lg">
          <RefreshCw size={15} />
          <span>Nuova versione disponibile</span>
          <button data-testid="update-apply" onClick={applyPwaUpdate} className="rounded-full bg-white/20 hover:bg-white/30 px-3 py-1 font-medium transition-colors">
            Aggiorna
          </button>
        </div>
      )}
    </div>
  );
}
